import React, {useState} from "react";
import {Select, DatePicker, Button, Table, Checkbox, message, Dropdown} from "antd";

const {Option} = Select;

export const ApplicationFilter = () => {
    const [selectedRows, setSelectedRows] = useState([]);

    const columns = [
        {
            title: <Checkbox/>,
            dataIndex: "checkbox",
            render: (_, record) => (
                <Checkbox
                    checked={selectedRows.includes(record.key)}
                    onChange={() => onSelectRow(record.key)}
                />
            ),
        },
        {
            title: "Ứng viên",
            dataIndex: "candidate",
        },
        {
            title: "Vị trí ứng tuyển",
            dataIndex: "position",
        },
        {
            title: "Ngày nộp",
            dataIndex: "date",
        },
        {
            title: "Loại hồ sơ",
            dataIndex: "type",
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            render: (status) => (
                <span
                    className={`px-2 py-1 rounded ${
                        status === "Đã duyệt" ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-700"
                    }`}
                >
          {status}
        </span>
            ),
        },
    ];

    const data = [
        {
            key: "1",
            candidate: "Nguyễn Văn A",
            position: "Lập trình viên Frontend",
            date: "20/02/2025",
            type: "Hồ sơ đầy đủ",
            status: "Đã duyệt",
        },
        {
            key: "2",
            candidate: "Trần Thị B",
            position: "Lập trình viên Backend",
            date: "18/02/2025",
            type: "Hồ sơ chưa đầy đủ",
            status: "Chờ xét duyệt",
        },
        {
            key: "3",
            candidate: "Lê Hoàng C",
            position: "Tester",
            date: "15/02/2025",
            type: "Hồ sơ đầy đủ",
            status: "Đã duyệt",
        },
    ];

    const onSelectRow = (key) => {
        setSelectedRows((prev) =>
            prev.includes(key) ? prev.filter((item) => item !== key) : [...prev, key]
        );
    };

    const handleSearch = () => {
        message.success('Tìm kiếm thành công!');
    };

    const handleUpdateStatus = () => {
        message.success('Cập nhật trạng thái thành công!');
    };

    const handleContact = () => {
        message.success('Liên hệ thành công!');
    };

    return (
        <>
            {/* Bộ lọc tìm kiếm */}
            <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-4">
                <Select className="w-full" defaultValue="Tất cả vị trí">
                    <Option value="all">Tất cả vị trí</Option>
                    <Option value="frontend">Lập trình viên Frontend</Option>
                    <Option value="backend">Lập trình viên Backend</Option>
                    <Option value="tester">Tester</Option>
                </Select>
                <DatePicker className="w-full" placeholder="Từ ngày"/>
                <DatePicker className="w-full" placeholder="Đến ngày"/>
                <Select className="w-full" defaultValue="Tất cả hồ sơ">
                    <Option value="all">Tất cả hồ sơ</Option>
                    <Option value="full">Hồ sơ đầy đủ</Option>
                    <Option value="incomplete">Hồ sơ chưa đầy đủ</Option>
                </Select>
                <Select className="w-full" defaultValue="Tất cả trạng thái">
                    <Option value="all">Tất cả trạng thái</Option>
                    <Option value="approved">Đã duyệt</Option>
                    <Option value="pending">Chờ xét duyệt</Option>
                </Select>
            </div>

            <div className="flex flex-col md:flex-row justify-between mb-4">
                <Button type="primary" onClick={handleSearch}>Tìm kiếm</Button>
                <div className="flex flex-col md:flex-row gap-2">
                    <Select className={"min-w-56"} defaultValue="Chọn hành động">
                        <Option value="approve">Không đến phỏng vấn</Option>
                        <Option value="reject">Loại bỏ</Option>
                    </Select>
                    <Button type="primary" onClick={handleContact}>Liên hệ</Button>
                </div>
            </div>

            {/* Bảng dữ liệu */}
            <Table
                columns={columns}
                dataSource={data}
                locale={{emptyText: "Không có dữ liệu"}}
                pagination={false}
                rowKey="key"
                scroll={{ x: 800 }}
            />
        </>
    );
};